<script>
    import {onMount} from "svelte";
    import {fly, fade, slide} from 'svelte/transition';
    import {flip} from 'svelte/animate';
    import {HasOnlySpaces, ShuffleArray} from "../../Common/Functions";
    import RangeSlider from "svelte-range-slider-pips";
    import Slider from "./Components/Slider.svelte";
    import Modal,{getModal} from './Components/Modal.svelte'
    import RecipeModal from "./Modals/RecipeModal.svelte";
    import TipModal from "./Modals/TipModal.svelte";
    import PancakeIsmModal from "./Modals/PancakeIsmModal.svelte";

    export let posts;

    let currentPostsLong;
    let currentPosts;
    let shuffledPosts;
    let currentShowingCount = 8;

    let loaded;

    let activeFilter = undefined;
    let slideValue = [2];

    let thumbn = '/wp-content/themes/hungryjack/images/default_recipe_img.jpg';


    function ResetPostCount() {
        currentShowingCount = 8;
    }

    function RefreshPostsFromType(type) {
        currentPostsLong = shuffledPosts.filter(value => value.type === type);
        currentPosts = currentPostsLong.slice(0, currentShowingCount);

    }

    onMount(async () => {

            startShowingPosts();
            loaded = true;

    })

    function startShowingPosts() {
        shuffledPosts = ShuffleArray(posts);
        RefreshPosts();
    }

    function RefreshPosts() {
        currentPostsLong = [...shuffledPosts];
        currentPosts = shuffledPosts.slice(0, currentShowingCount)
    }

    function onClearFiltersClicked() {
        activeFilter = undefined;
        slideValue = [2];
        ResetPostCount()
        RefreshPosts();
    }
    function onRecipesClicked() {
        ResetPostCount()
        RefreshPostsFromType('recipes')
        activeFilter = 'recipes';

    }

    function onTipsClicked() {
        ResetPostCount();
        RefreshPostsFromType('tips')
        activeFilter = 'tips';
        slideValue = [0];
    }

    function onPancakeIsmClicked() {
        ResetPostCount();
        RefreshPostsFromType('pancake-isms')
        activeFilter = 'pancake-isms';
        slideValue = [4];
    }

    function onSliderChange() {
        if (slideValue[0] === 0) {
            onTipsClicked();
        } else if (slideValue[0] === 4) {
            onPancakeIsmClicked();
        } else {
            onClearFiltersClicked();
        }
    }

    function onViewMoreCLicked() {
        currentShowingCount += 8;
        if (!HasOnlySpaces(activeFilter)) RefreshPostsFromType(activeFilter);
        else RefreshPosts();

    }

    const onPostClicked = (id, type) => {
        if(type === 'recipes') {
            $: {
                var a = new CollapsableContent();
                a.init();
                jQuery('.fb-share')
                    .on('click', fbShareClickHandler)
                    .on('keydown', fbShareKeydownHandler);


                function fbShareClickHandler(event) {
                    event.preventDefault();

                    fbShare(jQuery(event.currentTarget));
                }

                function fbShareKeydownHandler(event) {
                    if (event.which === 13) {
                        event.preventDefault();

                        fbShare(jQuery(event.currentTarget));
                    }
                }


                function fbShare(target) {
                    function trackEvent(category, action, label) {
                        if (category) {
                            ga('send', 'event', category, action, label);
                        }
                    }
                    function trackFacebook(target) {
                        trackEvent(getCategory(target), 'Facebook', getLabel(target));
                    }

                    function getLabel(target) {
                        return target.data('ga-label') || jQuery.trim(target.text());
                    }

                    function getCategory() {
                        var category = target.data('ga-category');

                        if (!category) {
                            var categoryContainer = target.closest('[data-ga-category-container]');

                            if (categoryContainer.length > 0) {
                                category = categoryContainer.data('ga-category-container');
                            }
                        }

                        return category;
                    }

                    FB.ui(
                        {
                            method: 'feed',
                            link: target.data('share-url') || location.href,
                            name: target.data('share-text'),
                            description: target.data('share-description') || null,
                            picture: target.data('share-image'),
                            caption: target.data('share-caption') || null
                        },
                        function (response) {
                            if (response && response.post_id) {
                                self.tracking.trackFacebook(target);
                            }
                        }
                    );
                }

            }
        }
        getModal('' + id).open()
    }

</script>
<main data-role="main">
    <!-- Banner Image and Title Section -->
    <section class="page-header">
        <div class="inner">
            <h1>Tricks, Tips, &amp; Flips <span>It's Time To Do Pancakes.</span></h1>
        </div>
    </section>
    <section class="intro">
        <div class="inner">
            <div class="highlight-image">
                <img alt="" src="/wp-content/themes/hungryjack/images/pancake-hub/syrup-bottle.png">

            </div>
        </div>
    </section>
    <Slider/>
    <section class="dig-in">
        <div class="inner">
            <h2>DIG IN.</h2>
            <p>Serious about upping your pancake game? In need of a flapjack-inspired laugh? Tell us what you're
                craving,
                and we'll serve up something that's sure to satisfy.</p>

            <div class="filter-scale-container">
                <div class="tips-marker label-marker">
                    <div>
                        I'm Hungry for<span>Knowledge</span>

                    </div>
                </div>
                <div class="filter-scale">
                    <RangeSlider step={1} bind:values={slideValue} min={0} max={4} on:change={(e) => onSliderChange()}/>
                </div>
                <div class="pancakeism-marker label-marker">
                    <div>
                        I'm Hungry for<span>Chuckles</span>

                    </div>
                </div>
            </div>
        </div>
        <div class="filter-container inner">
            <div>SWEET, FLUFFY RESULTS</div>
            <ul class="filters">
                <li>FILTER RESULTS</li>
                <li>
                    <span class="{activeFilter === 'tips' ? 'active' : ''}" on:click={onTipsClicked}>TIPS</span>
                </li>
                <li>
                    <span class="{activeFilter === 'recipes' ? 'active' : ''}" on:click={onRecipesClicked}>RECIPES</span>
                </li>
                <li>
                    <span class="{activeFilter === 'pancake-isms' ? 'active' : ''}" on:click={onPancakeIsmClicked}>PANCAKE-ISMS</span>
                </li>
                <li>
                    <span on:click={onClearFiltersClicked}>CLEAR FILTERS</span>
                </li>
            </ul>
        </div>
    </section>

    <section class="hub-item-container">
        <div class="inner">
            {#if loaded}
                <div class="hub-grid">
                    {#each currentPosts as post, i (post)}
                        <div class="fancybox fancybox.ajax" on:click={() => onPostClicked(post.id, post.type)} data-type="tip" animate:flip="{{duration: 800}}" transition:fade="{{duration: 400}}">
                            <div class="hub-item tip">
                                <div class="hub-image" style="background-image: url({!HasOnlySpaces(post.thumbnail) ? post.thumbnail : thumbn})"></div>
                                {#if post.type !== 'recipes'}
                                <span class="hub-item-type">{post.type}</span>
                                {/if}
                                <h3>{post.title}</h3>
                            </div>
                        </div>

                    {/each}
                    {#each currentPosts as post, i (post)}
                        {#if post.type === 'recipes'}
                            <Modal id="{post.id}">
                                <RecipeModal recipe={post} thumbnail={!HasOnlySpaces(post.thumbnail) ? post.thumbnail : thumbn}/>
                            </Modal>
                        {:else if post.type == 'tips'}
                            <Modal id="{post.id}">
                                <TipModal tip={post}/>
                            </Modal>

          {:else}
          <Modal id="{post.id}">
            <PancakeIsmModal tip={post}/>
          </Modal>
          {/if}
          {/each}
                </div>
                {#if currentPosts.length < currentPostsLong.length }
                    <div class="view-more-container">
                        <a class="view-more cta red arrow" on:click={onViewMoreCLicked} transition:fade>View More</a>
                    </div>
                {/if}
            {/if}
        </div>

    </section>

    <section class="monthly-flapjack">
        <div class="inner">
            <h2>Flapjack of the Month<span>Do Your 'Cakes Have What It Takes?</span></h2>
            <p>Now that you've fine-tuned your flapjack chops, show us what you've got! Share a picture of your most
                picturesque pancakes on Facebook<sup>®</sup> for a chance for yours to be named the next Flapjack of the
                Month.
            </p>
            <div><a class="cta arrow white" href="//www.facebook.com/hungryjack/" target="_blank">Show Us Your Pancake Pics</a></div>
        </div>
    </section>
</main>

<style>
    a.fancybox.fancybox\.ajax {
        display: flex;
    }
    .fancybox.fancybox\.ajax {
        display: flex;
        flex: 1 1 25%;
        justify-content: center;
        max-width: 409px !important;
    }
    .hub-grid {
        display: flex !important;
        flex-wrap: wrap;
        flex: 1 1 21%;
        justify-content: flex-start !important;
        width: 110% !important;
        margin-left: -5%;
    }

    .hub-item {
        width: 100% !important;
        height: 100%;
        display: flex !important;
        flex-direction: column;
        flex: 1 1 25%;
        cursor: pointer;
    }

    .hub-item.tip {
        max-width: 240px;
        max-height: 346px;
        margin-bottom: 30px;
        padding: 15px;
    }
    .hub-image {
        width: 210px;
        height: 215px;
    }
    .intro:before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        padding-top: 5.15625%;
        background: inherit;
        -webkit-clip-path: polygon(calc(100% - 1890px) 98px, 100% 0, 100% 100%, 0 100%);
        -moz-clip-path: polygon(calc(100% - 1890px) 98px, 100% 0, 100% 100%, 0 100%);
        -ms-clip-path: polygon(calc(100% - 1890px) 98px, 100% 0, 100% 100%, 0 100%);
        clip-path: polygon(calc(100% - 1890px) 98px, 100% 0, 100% 100%, 0 100%);
        clip-path: url(#clip-shape);
    }

    .intro {
        padding-bottom: calc(5.15625% + 60px);
    }
    p+h3, div+h3 {
        margin-top: 0 !important;
    }

    .hub-image {
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: cover;
    }

</style>